import { FAILURE, REQUEST, SUCCESS } from 'utils/actionTypeUtil';
import { API_URL } from 'constants/apiUrl';
import axios from 'axios';

const apiUrl = `${API_URL}/course_category`;

export const ACTION_TYPES = {
  FETCH_COURSECATEGORY_LIST: 'coursecategory/FETCH_COURSECATEGORY_LIST',
  FETCH_COURSECATEGORY: 'coursecategory/FETCH_COURSECATEGORY',
  CREATE_COURSECATEGORY: 'coursecategory/CREATE_COURSECATEGORY',
  UPDATE_COURSECATEGORY: 'coursecategory/UPDATE_COURSECATEGORY',
  DELETE_COURSECATEGORY: 'coursecategory/DELETE_COURSECATEGORY',
  RESET: 'coursecategory/RESET',
};

const initial = {
  loading: false,
  errorMessage: null,
  updating: false,
  updateSuccess: false,
  entities: [],
  entity: {}, //defaultValue
  pageable: {
    sort: {
      sorted: false,
      unsorted: true,
      empty: true,
    },
    pageSize: 10,
    pageNumber: 0,
    offset: 0,
    paged: true,
    unpaged: false,
  },
  totalElements: 0,
  last: false,
  totalPages: 0,
  sort: {},
  first: true,
  numberOfElements: 0,
  size: 0,
  number: 0,
  empty: true,
};

// REDUCER
const courseCategoryReducer = (state = initial, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_COURSECATEGORY_LIST):
    case REQUEST(ACTION_TYPES.FETCH_COURSECATEGORY):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_COURSECATEGORY):
    case REQUEST(ACTION_TYPES.UPDATE_COURSECATEGORY):
    case REQUEST(ACTION_TYPES.DELETE_COURSECATEGORY):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_COURSECATEGORY_LIST):
    case FAILURE(ACTION_TYPES.FETCH_COURSECATEGORY):
    case FAILURE(ACTION_TYPES.CREATE_COURSECATEGORY):
    case FAILURE(ACTION_TYPES.UPDATE_COURSECATEGORY):
    case FAILURE(ACTION_TYPES.DELETE_COURSECATEGORY):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_COURSECATEGORY_LIST):
      let res = action.payload.data;
      return {
        ...state,
        loading: false,
        entities: res.content,
        pageable: {
          sort: {
            sorted: res.pageable.sort.sorted,
            unsorted: res.pageable.sort.unsorted,
            empty: res.pageable.sort.empty,
          },
          pageSize: res.pageable.page_size,
          pageNumber: res.pageable.page_number,
          offset: res.pageable.offset,
          paged: res.pageable.paged,
          unpaged: res.pageable.unpaged,
        },
        totalElements: res.total_elements,
        last: res.last,
        totalPages: res.total_pages,
        sort: res.sort,
        first: res.first,
        numberOfElements: res.number_of_elements,
        size: res.size,
        number: res.number,
        empty: res.empty,
      };
    case SUCCESS(ACTION_TYPES.FETCH_COURSECATEGORY):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_COURSECATEGORY):
    case SUCCESS(ACTION_TYPES.UPDATE_COURSECATEGORY):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_COURSECATEGORY):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return { ...initial };
    default:
      return state;
  }
};

export default courseCategoryReducer;

// ACTIONS
export const getEntities = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_COURSECATEGORY_LIST,
  payload: axios.get(apiUrl, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
    },
  }),
});

export const getEntity = id => ({
  type: ACTION_TYPES.FETCH_COURSECATEGORY,
  payload: axios.get(`${apiUrl}/${id}`),
});

export const createEntity = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_COURSECATEGORY,
    payload: axios.post(apiUrl, entity),
    meta: { successMessage: `Berhasil simpan!` },
  });
  return result;
};

export const updateEntity = (entity, id) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_COURSECATEGORY,
    payload: axios.patch(`${apiUrl}/${id}`, entity),
    meta: { successMessage: `Berhasil update!` },
  });
  return result;
};

export const deleteEntity = id => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_COURSECATEGORY,
    payload: axios.delete(`${apiUrl}/${id}`),
    meta: {
      errorMessage: `Gagal hapus, Kategori telah Digunakan`,
      successMessage: `Berhasil Hapus!`,
    },
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
